import { Link, useLocation } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-4 bg-background-50">
      <p className="font-display text-[6rem] md:text-[9rem] leading-none text-primary-500/30 select-none">
        404
      </p>
      <h1 className="mt-2 text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
        页面不存在或已被移除
      </h1>
      <p className="mt-3 text-sm text-foreground-500 font-mono">{location.pathname}</p>
      <p className="mt-4 text-foreground-600 max-w-md">
        你访问的页面可能已下线，或者地址输入有误。不如回到首页，继续探索精彩影视与资讯。
      </p>
      <Link
        to="/"
        className="mt-7 inline-flex items-center gap-2 px-6 h-11 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors"
      >
        <i className="ri-home-4-line" />
        返回首页
      </Link>
    </div>
  );
}